import React, { useState } from 'react';

import './styles.css';
import NumberSpinner from '../NumberSpinner';

type Props = {
  callback: any;
};

const Score = ({
  callback,
}: Props) => {
  const [total, setTotal] = useState<number>(0);

  function changeValue(value: number) {
    const change = value - total;

    setTotal(total + change);
    callback(change);
  }

  return (
    <div className={'score-value'}>
      <NumberSpinner
        min={0}
        value={total}
        onChange={changeValue}
      />
    </div>
  );
};

export default Score;